class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

		const autoDelay = 1500;
		const fadeSpeed = 2500;
		// 表示サイクル（delay + fade）＋フェードアウト中も拡大が続くようにする
		const slideCycle = autoDelay + fadeSpeed;
		const zoomDuration = (slideCycle + fadeSpeed) / 1000;

		const getSlideBg = (slide) => slide && slide.querySelector(':scope > div');

		const getSlidesByRealIndex = (swiper, realIndex) => {
			return Array.from(swiper.slides).filter((slide) => {
				const index = slide.getAttribute('data-swiper-slide-index');
				return index !== null && Number(index) === realIndex;
			});
		};

		const zoomActiveSlide = (swiper) => {
			const targets = getSlidesByRealIndex(swiper, swiper.realIndex)
				.map(getSlideBg)
				.filter(Boolean);

			if (!targets.length) {
				const fallback = getSlideBg(swiper.slides[swiper.activeIndex]);
				if (fallback) targets.push(fallback);
			}

			targets.forEach((activeBg) => {
				gsap.killTweensOf(activeBg);
				gsap.fromTo(activeBg,
					{ scale: 1 },
					{
						scale: 1.1,
						duration: zoomDuration,
						ease: 'linear'
					}
				);
			});
		};

		const resetInactiveSlides = (swiper) => {
			const activeSlides = new Set(getSlidesByRealIndex(swiper, swiper.realIndex));

			swiper.slides.forEach((slide) => {
				if (activeSlides.has(slide)) return;
				const bg = getSlideBg(slide);
				if (!bg) return;
				gsap.killTweensOf(bg);
				gsap.set(bg, { scale: 1 });
			});
		};

		let swiperMv = null;

		// function splitTextKeepBr(target) {
		// 	const els = document.querySelectorAll(target);
		// 	if (!els.length) return;
		
		// 	els.forEach((el) => {
		// 		const nodes = Array.from(el.childNodes);
		// 		el.innerHTML = '';
		
		// 		nodes.forEach((node) => {
		// 			// テキストノードだけ1文字ずつspan化
		// 			if (node.nodeType === Node.TEXT_NODE) {
		// 				const text = node.textContent;
		
		// 				text.split('').forEach((char) => {
		// 					const span = document.createElement('span');
		
		// 					if (char === ' ') {
		// 						span.innerHTML = '&nbsp;';
		// 					} else {
		// 						span.textContent = char;
		// 					}
		
		// 					el.appendChild(span);
		// 				});
		// 			}
		
		// 			// brはそのまま戻す
		// 			if (node.nodeName === 'BR') {
		// 				el.appendChild(document.createElement('br'));
		// 			}
		// 		});
		// 	});
		// }
		
		// splitTextKeepBr('.js-mv-copy');
		// document.querySelectorAll('.js-mv-copy-line').forEach((line) => {
		// 	const text = line.innerHTML;
		// 	line.innerHTML = `<span>${text}</span>`;
		// });
	

		// =========================
		// Swiper 初期化
		// =========================
		function initMvSwiper() {
			if (swiperMv) return;

			swiperMv = new Swiper('.js-swiper-mv', {
				slidesPerView: 1,
				loop: true,
				speed: fadeSpeed,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: autoDelay,
					disableOnInteraction: false
				},
				allowTouchMove: false,
				on: {
					init: function () {
						// 文字アニメ完了まではタイマーを動かさない
						this.autoplay.stop();
					},

					slideChangeTransitionStart: function () {
						// 開始前の内部slideChangeでは拡大をやり直さない（縮小チラつき防止）
						if (!this._mvReady) return;
						zoomActiveSlide(this);
					},

					slideChangeTransitionEnd: function () {
						if (!this._mvReady) return;
						resetInactiveSlides(this);
					}
				}
			});
		}

		function startMvSwiper() {
			if (!swiperMv || swiperMv._mvReady) return;

			requestAnimationFrame(() => {
				zoomActiveSlide(swiperMv);
				swiperMv._mvReady = true;
				// 2枚目以降: フェードイン(fadeSpeed) + delay のあとで切り替わる
				// 1枚目は最初から表示済みなので、フェードイン相当を待ってから autoplay 開始
				setTimeout(() => {
					if (!swiperMv) return;
					swiperMv.autoplay.start();
				}, fadeSpeed - 500);
			});
		}


		// =========================
		// 初回セッションのみイントロを再生
		// =========================
		const MV_INTRO_KEY = 'tciMvIntroPlayed';
		let hasPlayedIntro = false;
		try {
			hasPlayedIntro = sessionStorage.getItem(MV_INTRO_KEY) === '1';
		} catch (e) {
			hasPlayedIntro = false;
		}

		const markIntroPlayed = () => {
			try {
				sessionStorage.setItem(MV_INTRO_KEY, '1');
			} catch (e) {}
		};

		if (hasPlayedIntro) {
			gsap.set('.js-mv-copy-line', { opacity: 1, y: 0 });
			gsap.set('.js-mv-subcopy', { opacity: 1, y: 0 });
			gsap.set('.js-mv-item', { opacity: 1 });
			gsap.set('.p-top', {
				opacity: 0
			});

			initMvSwiper();
			startMvSwiper();

			gsap.to('.p-top', {
				opacity: 1,
				duration: 0.2,
				ease: 'power2.out'
			});
		} else {
			// =========================
			// 初期状態
			// =========================
			gsap.set('.p-top', {
				opacity: 0
			});

			gsap.set('.js-mv-copy-line', {
				opacity: 0,
				y: '7rem'
			});

			gsap.set('.js-mv-subcopy', {
				opacity: 0,
				y: '1rem'
			});

			gsap.set('.js-mv-item', {
				opacity: 0
			});

			// =========================
			// MV表示アニメーション
			// =========================
			const mvTl = gsap.timeline({
				onStart: markIntroPlayed
			});

			mvTl
			.call(initMvSwiper)
			.to('.p-top', {
				opacity: 1,
				duration: 0.8,
				ease: 'power2.out'
			})

			.to('.js-mv-copy-line', {
				y: 0,
				opacity: 1,
				duration: 1.0,
				ease: 'power3.out',
				stagger: 0.1
			}, 1) // テキスト出現開始を1秒後に

			.to('.js-mv-subcopy', {
				opacity: 1,
				y: 0,
				duration: 0.8,
				ease: 'power3.out'
			}, '<-=0.02')

			// 文字が出揃ってからスライド時間（autoplay / zoom）を開始
			.call(startMvSwiper)

			.to('.js-mv-item', {
				opacity: 1,
				duration: 0.8,
				ease: 'power2.out'
			});
		}
		
		// const swiperMv = new Swiper('.js-swiper-mv', {
		// 	slidesPerView: 1,
		// 	loop: true,
		// 	speed: fadeSpeed,
		// 	effect: 'fade',
		// 	fadeEffect: {
		// 		crossFade: true
		// 	},
		// 	autoplay: {
		// 		delay: autoDelay,
		// 		disableOnInteraction: false
		// 	},
		// 	allowTouchMove: false,
		// 	on: {
		// 		init(swiper) {
		// 			requestAnimationFrame(() => {
		// 				zoomActiveSlide(swiper);
		// 			});
		// 		},
		
		// 		slideChangeTransitionStart(swiper) {
		// 			// 次に表示されるスライドだけ拡大開始
		// 			zoomActiveSlide(swiper);
		// 		},
		
		// 		slideChangeTransitionEnd(swiper) {
		// 			// フェードが終わって、見えなくなってから他スライドをリセット
		// 			resetInactiveSlides(swiper);
		// 		}
		// 	}
		// });

		const peopleSwiperEl = document.querySelector('.js-people-swiper');
		if (peopleSwiperEl) {
			// loop 複製前の本来の枚数（複製後に数えるとずれる）
			const peopleSlideCount = peopleSwiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

			const updatePeoplePagination = (swiper) => {
				const total = swiper.params.loop
					? peopleSlideCount
					: swiper.slides.length;
				const totalEl = peopleSwiperEl.querySelector(".js-total-num");
				const nowEl = peopleSwiperEl.querySelector(".js-now-num");
				if (totalEl) {
					totalEl.textContent = String(total).padStart(2, "0");
				}
				if (nowEl) {
					nowEl.textContent = String(swiper.realIndex + 1).padStart(2, "0");
				}
			};

			// init 内の slideToLoop は loop 未完成のまま DOM 先頭（最終スライドの複製）へ飛ぶことがある
			const swiper = new Swiper(peopleSwiperEl, {
				loop: peopleSlideCount > 1,
				slidesPerView: 1.2,
				centeredSlides: true,
				spaceBetween: 20,
				initialSlide: 0,
				loopedSlides: peopleSlideCount,
				loopAdditionalSlides: peopleSlideCount,
				threshold: 10,
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 0,
						centeredSlides: true,
						slidesOffsetAfter: 900,
					}
				},
				navigation: {
					prevEl: ".js-people-prev",
					nextEl: ".js-people-next"
				},
				on: {
					init: function () {
						updatePeoplePagination(this);
					},
					slideChange: function () {
						updatePeoplePagination(this);
					},
				}
			});

			// loop 時は先頭に最終スライドの複製が並ぶため、実スライド先頭（loopedSlides）へ合わせる
			// ※init 内の slideToLoop(0) だと複製先頭＝最終記事に飛ぶことがある
			if (peopleSlideCount > 1) {
				requestAnimationFrame(() => {
					swiper.slideTo(swiper.loopedSlides || 0, 0);
					updatePeoplePagination(swiper);
				});
			}
		}

		const workSwiperEl = document.querySelector('.js-work-swiper');

		if (workSwiperEl) {
			const workPcQuery = window.matchMedia('(min-width: 768px)');
			const workTotal = workSwiperEl.querySelectorAll('.swiper-slide').length;
			const workNowNumEl = workSwiperEl.querySelector('.js-work-now-num');
			const workTotalNumEl = workSwiperEl.querySelector('.js-work-total-num');
			let workSwiper = null;

			if (workTotalNumEl) {
				workTotalNumEl.textContent = String(workTotal).padStart(2, "0");
			}

			const setWorkCurrent = (swiper, isPc) => {
				// PCは左端に前のスライドを見せ、その右隣（左から2番目）をcurrentにする
				const currentSlide = swiper.slides[swiper.activeIndex + (isPc ? 1 : 0)];

				swiper.slides.forEach((slide) => {
					slide.classList.toggle('is-current', slide === currentSlide);
				});

				if (!currentSlide || !workNowNumEl) return;

				// ループ複製スライドは元スライドの番号を持つ
				const slideIndex = currentSlide.getAttribute('data-swiper-slide-index');
				const current = slideIndex === null ? swiper.activeIndex : Number(slideIndex);

				workNowNumEl.textContent = String(current + 1).padStart(2, "0");
			};

			// SPはコンテナの左paddingとスライド間の余白を揃えることで、前のスライドがちょうど画面外に隠れる
			const getWorkSpaceBetween = (isPc) => {
				if (isPc) return 20;
				return parseFloat(getComputedStyle(workSwiperEl).paddingLeft) || 20;
			};

			const initWorkSwiper = (isPc) => {
				if (workSwiper) {
					workSwiper.destroy(true, true);
					workSwiper = null;
				}

				workSwiper = new Swiper(workSwiperEl, {
					// 幅はCSS固定（PC:35×53 / SP:26.4×40）のため auto で縦横比を維持
					slidesPerView: 'auto',
					spaceBetween: getWorkSpaceBetween(isPc),
					centeredSlides: false,
					loop: true,
					loopAdditionalSlides: 3,
					slidesOffsetAfter: isPc ? 900 : 0,
					threshold: 10,
					// 最終スライドを左端に置くことで、ライフサイエンスが最初のcurrentになる
					initialSlide: isPc ? Math.max(workTotal - 1, 0) : 0,

					navigation: {
						prevEl: ".js-work-prev",
						nextEl: ".js-work-next"
					},

					on: {
						init: function () {
							setWorkCurrent(this, isPc);
						},

						activeIndexChange: function () {
							setWorkCurrent(this, isPc);
						},

						loopFix: function () {
							setWorkCurrent(this, isPc);
						},

						// remは画面幅連動のため、リサイズ後もpaddingと余白を揃え直す
						resize: function () {
							this.params.spaceBetween = getWorkSpaceBetween(isPc);
							this.update();
						}
					}
				});
			};

			initWorkSwiper(workPcQuery.matches);

			workPcQuery.addEventListener('change', (event) => {
				initWorkSwiper(event.matches);
			});
		}
	
	
	}
}